var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-card"},[(_vm.header)?_c('div',{staticClass:"select-card-title"},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.header))]})],2):_vm._e(),_c('el-scrollbar',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }